const { event } = require("jquery");

define([
  "jquery",
  "underscore",
  "marionette",
  "behaviors/form_errors_behavior",
  "backbone.syphon"
], function($, _, Marionette, FormErrorsBehavior) {
  return Marionette.View.extend({
      el: '#content_layout',

      behaviors: {
          formErrors: {
              behaviorClass: FormErrorsBehavior
          }
      },

      ui: {
        'btnPrev': '#btn-prev',
        'btnNext': '#btn-next',
        'pageNubmers': '.page-number',
        'tbody': '#bonus-table-rows',
      },

      events: {
        'click @ui.btnPrev': 'displayPrevData',
        'click @ui.btnNext': 'displayNextData',
        'click @ui.pageNubmers': 'displayPageNubmerData',
      },

      initialize: function(){
        this.bindUIElements();
      },

      displayPageNubmerData: function(e) {
        e.preventDefault();

        const oldPageNumber = this.getSelectedPageNumber();
        const clickedPageNumber = $(e.target).data('page')
        const pagination = this.paginate(window.daily_bonus_histories, clickedPageNumber)

        this.renderBonusTable(pagination.data)

        this.showBtnNext()
        this.showBtnPrev()

        if(clickedPageNumber == 1) {
          this.hideBtnPrev()
        }

        if(clickedPageNumber == pagination.totalPages) {
          this.hideBtnNext()
        }

        this.renderSelectedNumber(oldPageNumber, clickedPageNumber)
      },

      displayPrevData: function(e) {
        e.preventDefault();
        
        const oldPageNumber = this.getSelectedPageNumber();
        const prevPageNumber = oldPageNumber - 1
        const pagination = this.paginate(window.daily_bonus_histories, prevPageNumber)

        this.renderBonusTable(pagination.data)
        this.showBtnNext()

        if(prevPageNumber == 1) {
          this.hideBtnPrev()
        }

        this.renderSelectedNumber(oldPageNumber, prevPageNumber)
      },

      hideBtnPrev: function() {
        this.ui.btnPrev.addClass('hidden')
      },

      showBtnNext: function() {
        this.ui.btnNext.removeClass('hidden')
      },

      displayNextData: function(e) {
        e.preventDefault();
        
        const oldPageNumber = this.getSelectedPageNumber();
        const nextPageNumber = oldPageNumber + 1
        const pagination = this.paginate(window.daily_bonus_histories, nextPageNumber)

        this.renderBonusTable(pagination.data)
        this.showBtnPrev()

        if(nextPageNumber == pagination.totalPages) {
          this.hideBtnNext()
        }

        this.renderSelectedNumber(oldPageNumber, nextPageNumber)
      },

      renderSelectedNumber: function(oldPageNumber, selectedPageNumber) {
        const oldNumber = $(`.page-number[data-page="${oldPageNumber}"]`)
        const newNumber = $(`.page-number[data-page="${selectedPageNumber}"]`)

        oldNumber.removeClass('select')
        newNumber.addClass('select')
      },

      hideBtnNext: function() {
        this.ui.btnNext.addClass('hidden')
      },

      showBtnPrev: function() {
        this.ui.btnPrev.removeClass('hidden')
      },

      renderBonusTable: function(histories) {
        const that = this
        
        this.ui.tbody.empty()

        histories.forEach(h => {
          const month = (new Date(h.date)).getMonth() + 1
          const day = (new Date(h.date)).getDate()
          const tr = `<tr>
              <td>${month} / ${day}</td>
              <td>
                <div class="medal-count-wrapper">
                  <div>${h.gold ? h.gold : 0}</div>
                  <div>${h.silver ? h.silver : 0}</div>
                  <div>${h.bronze ? h.bronze : 0}</div>
                </div>
              </td>
              <td>${h.total_daily_received_bonus ? Intl.NumberFormat('en-US').format(h.total_daily_received_bonus) : 0}</td>
              <td>${h.hidden_event_amount ? Intl.NumberFormat('en-US').format(h.hidden_event_amount) : 0}</td>
              <td>${h.max_bonus_amount ? Intl.NumberFormat('en-US').format(h.max_bonus_amount) : 0}</td>
            </tr>`
          that.ui.tbody.append(tr)
        });
      },

      getSelectedPageNumber: function() {
        const selectedPage = $('.page-number.select').first()
        return selectedPage.data('page')
      },

      paginate: function(items, page = 1, perPage = 5) {
        const totalItems = items.length;
        const totalPages = Math.ceil(totalItems / perPage);

        if (page > totalPages) {
            page = totalPages;
        }
        if (page < 1) {
            page = 1;
        }

        const startIndex = (page - 1) * perPage;
        const pagedItems = items.slice(startIndex, startIndex + perPage);

        return {
            page: page,
            perPage: perPage,
            totalItems: totalItems,
            totalPages: totalPages,
            data: pagedItems
        };
      },
  });
});